import React from 'react'
import { LineChart, Line, XAxis, YAxis, Tooltip, Legend, CartesianGrid, ResponsiveContainer } from 'recharts';
import styles from '../MultivariateAnalysis.module.css';


function LineChartComponent({ data, dataKeys }) {
    const transformedData = data.map((d, index) => ({
        name: dataKeys[index],
        efficientTrips: d.efficientTrips,
        inefficientTrips: d.inefficientTrips,
    }));

    return (
        <ResponsiveContainer width="100%" height={300}>
            <LineChart data={transformedData} margin={{ top: 20, right: 30, left: 20, bottom: 5 }}>
                <CartesianGrid strokeDasharray="3 3" stroke="#d1d5db" />
                <XAxis dataKey="name" padding={{ left: 30, right: 30 }} stroke="#6b7280" />
                <YAxis stroke="#6b7280" tickFormatter={v => `${(v * 100).toFixed(0)}%`} />
                <Tooltip content={<CustomTooltip />} />
                <Legend align="center" verticalAlign="bottom" wrapperStyle={{ paddingBottom: '10px' }} />
                <Line type="monotone" dataKey="efficientTrips" stroke="#22c55e" activeDot={{ r: 8 }} strokeWidth={2} name="Efficient Trips" />
                <Line type="monotone" dataKey="inefficientTrips" stroke="#ef4444" activeDot={{ r: 8 }} strokeWidth={2} name="Inefficient Trips" />
            </LineChart>
        </ResponsiveContainer>
    );
}

export default LineChartComponent


const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload.length) {
        const data = payload[0].payload;
        return (
            <div className={styles['tooltip-box']}>
                <p className={styles['tooltip-title']}>Data Point</p>
                <p className={styles['tooltip-efficient']}>Efficient Trips: {data.efficientTrips}</p>
                <p className={styles['tooltip-inefficient']}>Inefficient Trips: {data.inefficientTrips}</p>
            </div>
        );
    }
    return null;
};
